import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledSearchMobile } from './organisms/searchMobile/searchMobile.styles';
import { SearchDesktopSecondary } from './molecules/searchSecondaryBar/searchSecondaryBar.styles';
import { StyledPopupDiv } from './atoms/popup/popup.styles';
import { SearchDesktopPrimary } from './organisms/searchDesktop/searchDesktop.styles';
import { StyledAddDatesDiv } from './molecules/addDates/addDates.styles';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledSearchContainer = styled.div.attrs((props: { desktopFormTopPadding: number }) => props)`
  ${rtl`
  background: ${theme.color.background};

  @media ${theme.mediaQuery.tablet} {
    margin-left: 0;
    margin-right: 0;
  }

  .search-primary-container.shop-page-search-container {
     @media ${theme.mediaQuery.tabletMax} {
      margin-top:${toRem(48)};
     }
    .container {
      padding:0;
    }
  }
  .search-primary-container.shop-page-search-container-spa {
    @media ${theme.mediaQuery.tabletMax} {
      margin-top:0;
    }
  }
  .search-primary-container.adf-search-container-tablet {
    @media ${baseVariables.mediaQuery.lg} {
    box-shadow: ${toRem(-15)} ${toRem(16)} ${toRem(20)} 0 ${baseVariables.shadows.boxShadowTile};
    }
    @media ${theme.mediaQuery.tabletMax} {
      margin-top:0;
      .container {
        padding:0;
        max-width:100%;
     }
    }
  }
  form {
    position: relative;
    padding:0;
    @media ${theme.mediaQuery.desktop} {
      margin-left: auto;
      margin-right: auto;
    }
  }

  &.map-view-sticky {
    .search-primary, .search-secondary {
      @media ${theme.mediaQuery.smallerTablet} {
        border-radius: 0;
      }
    }
  }
  
  form:focus-visible {
    outline: none;
  }
    
  &.sticky-search-container {
    position: fixed;
    width: 100%;
    top: ${toRem(0)};
    background: ${theme.color.white};;
    margin-top: ${toRem(0)} !important;
    z-index: 50;
    padding-bottom: ${toRem(10)};
    padding: 0 !important ;
    box-shadow: ${theme.color['container-box-shadow']};
    form{
      max-width: 100%;
      .search-primary-container{
        box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
        margin-top: ${toRem(0)};
        position: inherit;
        .search-primary{
          box-shadow: none;
        }
      }
      .search-secondary{
        margin: auto;
        box-shadow: none;
        padding-bottom: ${toRem(4)} !important;
        padding-top: ${toRem(4)} !important;
      }
    }

    .container {
      @media ${theme.mediaQuery.smallerTablet} {
        padding: 0;
      }
    }

    .search-primary, .search-secondary {
      border-radius: 0 !important;

    }
  }
  .special-rates-popup{
    overflow-y:hidden;
  }
  .custom-scrollbar {
    ::-webkit-scrollbar-thumb {
      border: ${toRem(4)} solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      border-radius: ${toRem(400)};
      background-color: ${theme.color['light-gray-9']};
    }
    ::-webkit-scrollbar {
      width: ${toRem(14)};
      height:${toRem(40)};
    }
    ::-webkit-scrollbar-track{
      background-color: ${theme.color['white']};
      border-radius: 0 ${toRem(14)} ${toRem(14)} 0;
    }
  }

  &.search-form-shop-page-container:focus-visible {
    outline: none;
  }


  &.search-form-shop-page-container {
    .adf-rates {
      ${StyledPopupDiv} {
        &:not(.custom-search-popup) {
          z-index: 7;
          inset-inline-start: 0;
        }
      }
    }
    
    @media ${theme.mediaQuery.minDesktop} {
      display:flex;
      flex-direction:column;
    }
    padding: ${toRem(0)} ${toRem(16)} 0 ${toRem(16)};

    @media ${theme.mediaQuery.mobileTablet} {
      padding: ${toRem(16)} 0 0;

      &.map-view-sticky {
        padding: ${toRem(16)} 0;

        .container {
          padding: 0;
        }
      }
    }

    @media ${theme.mediaQuery.mobileOnly} {
      padding: ${toRem(66)} ${toRem(16)} 0 ${toRem(16)};
    }
    &.serp-mobile-height-for-spa {
      @media ${theme.mediaQuery.mobileOnly} {
        padding: ${toRem(18)} ${toRem(16)} 0 ${toRem(16)};
      }
    }

    &.map-view-sticky {
      padding: 0;
    }

    ${SearchDesktopPrimary}, ${SearchDesktopSecondary} {
      @media ${theme.mediaQuery.mobileTablet} {
        padding-left: ${toRem(16)} !important;
        padding-right: ${toRem(20)} !important;
      }
      @media ${theme.mediaQuery.desktop} {
        padding-left: ${toRem(16)} !important;
        padding-right: ${toRem(20)} !important;
      }
    }
    ${SearchDesktopPrimary} {
      @media ${theme.mediaQuery.desktop} {
        padding-left: ${toRem(20)} !important;
      }
    }
    ${SearchDesktopSecondary} {
      @media ${baseVariables.mediaQuery.md} {
        &.adf-search-bar{
          max-width: 100%;
        }
      }
      @media ${baseVariables.mediaQuery.lg} {
        &.adf-search-bar{
          max-width: ${toRem(1140)};
        }
      }
      @media ${theme.mediaQuery.desktop} {
        padding-left: ${toRem(20)} !important;

        &.adf-search-bar {
          border-radius:0;
          background: transparent;
          margin: auto;
          box-shadow: none !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
          padding-top: ${toRem(19)} !important;
        }
      } 
    }
    ${StyledPopupDiv} {
     
      &:not(.custom-search-popup) {
        @media ${theme.mediaQuery.desktop} {
          padding-left: ${toRem(20)} !important;
          padding-right: ${toRem(20)} !important;
          width: ${toRem(378)};
          .special-rates-popup {
            top: ${toRem(-5)};
          }
          &.close-popup-header {
            width: ${toRem(285)};
            padding-bottom: ${toRem(4)};
          }
        }
        @media ${theme.mediaQuery.smallerTablet} {
          &.close-popup-header {
            .special-rates-dropdown {
              .search-button {
                max-width: ${toRem(170)} !important;
              }
            }
          }
        }
      }
    }
    &.sticky,
    &.map-view-sticky {
      position: fixed;
      top: 0;
      margin: 0;
    }
    &.map-view-sticky {
      position: static !important;
      padding-top: ${toRem(0)} !important;
      ${SearchDesktopPrimary} {
        @media ${theme.mediaQuery.largeTablet} {
          padding-left: ${toRem(9)} !important;
        }
        @media ${theme.mediaQuery.smallerTablet} {
          padding-left: ${toRem(3)} !important;
        }
      }
      ${SearchDesktopSecondary} {
        @media ${theme.mediaQuery.largeTablet} {
          padding-left: ${toRem(16)} !important;
        }
        @media ${theme.mediaQuery.smallerTablet} {
          padding-left: ${toRem(3)} !important;
        }
      }
    }
  }
  &.adf-search-form-container-mobile {
    padding-left:0;
    padding-right:0;
    padding-top:0 !important;
  }
  &.adf-search-form-container {
    background-color: ${theme.color.white};
    padding-left:0 !important;
    padding-right:0 !important;
    padding-top:0 !important;
    .adf-form-wrapper {
      max-width: 100%;
      @media ${baseVariables.mediaQuery.lg} {
        box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 ${baseVariables.shadows.boxShadowTile};
      }


      ${SearchDesktopPrimary}, ${SearchDesktopSecondary} {
        border-radius: 0 !important;
        padding-left: ${toRem(32)} !important;
        padding-right: ${toRem(32)} !important;

        @media ${theme.mediaQuery.minDesktop} {
          padding-left: 0 !important;
          padding-right: 0 !important;
          box-shadow: none !important;
        }
      }
    }
    
  }
  &.sticky,
  &.map-view-sticky {
    background-color: ${theme.color.white};
    width: 100%;
    z-index: 5;
    & > div {
      box-shadow: none;
    }
    form {
      padding: 0;
      max-width: unset;
      @media ${theme.mediaQuery.desktop} {
        max-width: 100%;
        margin-left: 0;
        margin-right: 0;
      }
    }
    .search-bar {
      @media ${theme.mediaQuery.tabletMax} {
        max-width: 100%;
      }
    }
    .search-primary-container {
      box-shadow: ${theme.color['container-box-shadow']};
      &.shop-page-search-container {
        .container {
          @media ${theme.mediaQuery.tabletMax} {
            max-width: 100%;
          }
          ${StyledAddDatesDiv} {
            ${StyledPopupDiv} {
              @media screen and (min-width: ${toRem(800)}) and (max-width: ${toRem(991)}) {
                left: -53.4% !important;
              }
            }
          }
          .with-input {
            @media ${theme.mediaQuery.mobileTablet} {
              padding-left: ${toRem(16)};
            }
          }
          .show-popup {
            @media ${theme.mediaQuery.mobileTablet} {
              left: -${toRem(2)};
              .with-input {
                padding-left: ${toRem(18)};
              }
            }
          }
        }
      }
      & > div > div {
        box-shadow: none;

        & > div > button,
        .with-input,
        .search-dates-popup,
        .hover-60 {
          padding-top: ${toRem(20)};
          @media ${theme.mediaQuery.desktop} {
            padding-top: ${toRem(16)};
          }
        }
        .find-btn {
          @media ${theme.mediaQuery.tablet} {
            right: ${toRem(36)};
          }
          @media ${theme.mediaQuery.desktop} {
            right: ${toRem(32)};
          }
        }
      }
      & + div {
        margin: -${toRem(14)} auto 0;
        background-color: inherit;
      }
    }

    .search-secondary {
      box-shadow: none;
    }
    .find-btn {
      &.search-page-btn {
        top: ${toRem(23)};
        @media ${theme.mediaQuery.allTablets} {
          right: ${toRem(35)};
        }
      }
      @media ${theme.mediaQuery.desktop} {
        &.search-page-btn {
          top: ${toRem(23)};
        }
      }
      @media ${baseVariables.mediaQuery.xl} {
        top: ${toRem(24)};
      }
    }
    .show-popup {
      @media ${theme.mediaQuery.mobileTablet} {
        .with-input {
          padding-left: ${toRem(24)};
        }
      }
    }

    ${StyledSearchMobile} {
      padding: ${toRem(16)} ${toRem(32)} ${toRem(20)};
      border-radius: 0;
      button {
        align-items: center;
        flex-direction: row;
      }
      &.mobile-search-page-form-container {
        padding: ${toRem(16)} ${toRem(20)} ${toRem(20)};
        button {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          span:first-child {
            display: none;
          }
          span.t-font-xs {
            display: block;
            color: ${theme.color['dark-gray-3']};
          }
        }
      }
      @media ${theme.mediaQuery.smallMobile} {
        padding-left: ${toRem(24)};
        padding-right: ${toRem(24)};

        .h-r-form-field-txt {
          font-size: ${toRem(16)};
        }
      }
      span {
        &:first-child {
          display: inline;
          font-size: ${toRem(14)};
        }
        &:nth-child(2) {
          display: none;
        }
      }
    }
  }

  .mobile-only-show {
    @media ${theme.mediaQuery.tablet} {
      display: none;
    }
  }

  .mobile-only-hide {
    @media ${theme.mediaQuery.mobileOnly} {
      display: none;
    }
  }

  .hover-60 {
    @media ${theme.mediaQuery.tablet} {
      cursor: pointer;
      &:hover {
        opacity: 0.6;
      }
    }
  }
`}
`;
